import api from "../api";

export const expendituresCategoriesService = {
  // Get all categories and types
  getCategories: async () => {
    try {
      console.log("📡 [SERVICE] Calling getCategories API");
      const response = await api.get("/expenditures/categories");
      console.log("📦 [SERVICE] API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw error;
    }
  },

  // Get all types
  getTypes: async () => {
    try {
      console.log("📡 [SERVICE] Calling getTypes API");
      const response = await api.get("/expenditures/types");
      console.log("📦 [SERVICE] Types API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching types:", error);
      throw error;
    }
  },

  // Create new category
  createCategory: async (data) => {
    try {
      const response = await api.post(
        "/expenditures/categories/create/category",
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error creating category:", error);
      throw error;
    }
  },

  // Create new type
  createType: async (data) => {
    try {
      const response = await api.post(
        "/expenditures/categories/create/type",
        data
      );
      return response.data;
    } catch (error) {
      console.error("Error creating type:", error);
      throw error;
    }
  },

  // Update category
  updateCategory: async (categoryId, data) => {
    try {
      const response = await api.post(
        "/expenditures/categories/edit/category",
        {
          category_id: categoryId,
          ...data,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating category:", error);
      throw error;
    }
  },

  // Update type
  updateType: async (typeId, data) => {
    try {
      const response = await api.post(
        "/expenditures/categories/edit/category/type",
        {
          type_id: typeId,
          ...data,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating type:", error);
      throw error;
    }
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    try {
      const response = await api.get(
        `/expenditures/categories/edit/category/${categoryId}/delete`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting category:", error);
      throw error;
    }
  },

  // Delete type
  deleteType: async (categoryId, typeId) => {
    try {
      const response = await api.get(
        `/expenditures/categories/edit/category/${categoryId}/type/${typeId}/delete`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting type:", error);
      throw error;
    }
  },

  // Get category by ID
  getCategory: async (categoryId) => {
    try {
      const response = await api.get(`/expenditures/categories/${categoryId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching category:", error);
      throw error;
    }
  },

  // Get type by ID
  getType: async (typeId) => {
    try {
      const response = await api.get(`/expenditures/types/${typeId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching type:", error);
      throw error;
    }
  },

  // Get categories with types
  getCategoriesWithTypes: async () => {
    try {
      const response = await api.get("/expenditures/categories/with-types");
      return response.data;
    } catch (error) {
      console.error("Error fetching categories with types:", error);
      throw error;
    }
  },

  // Get types by category
  getTypesByCategory: async (categoryId) => {
    try {
      const response = await api.get(
        `/expenditures/categories/${categoryId}/types`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching types by category:", error);
      throw error;
    }
  },

  // Search categories
  searchCategories: async (query) => {
    try {
      const response = await api.get(
        `/expenditures/categories/search?q=${query}`
      );
      return response.data;
    } catch (error) {
      console.error("Error searching categories:", error);
      throw error;
    }
  },

  // Search types
  searchTypes: async (query) => {
    try {
      const response = await api.get(`/expenditures/types/search?q=${query}`);
      return response.data;
    } catch (error) {
      console.error("Error searching types:", error);
      throw error;
    }
  },

  // Get category statistics
  getCategoryStatistics: async (categoryId) => {
    try {
      const response = await api.get(
        `/expenditures/categories/${categoryId}/statistics`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching category statistics:", error);
      throw error;
    }
  },

  // Get type statistics
  getTypeStatistics: async (typeId) => {
    try {
      const response = await api.get(
        `/expenditures/types/${typeId}/statistics`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching type statistics:", error);
      throw error;
    }
  },

  // Export categories as CSV
  exportCategoriesCSV: async () => {
    try {
      const response = await api.get("/expenditures/categories/export/csv", {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting categories CSV:", error);
      throw error;
    }
  },

  // Export types as CSV
  exportTypesCSV: async () => {
    try {
      const response = await api.get("/expenditures/types/export/csv", {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      console.error("Error exporting types CSV:", error);
      throw error;
    }
  },

  // Get categories with expenditure counts
  getCategoriesWithCounts: async () => {
    try {
      const response = await api.get("/expenditures/categories/with-counts");
      return response.data;
    } catch (error) {
      console.error("Error fetching categories with counts:", error);
      throw error;
    }
  },

  // Get types with expenditure counts
  getTypesWithCounts: async () => {
    try {
      const response = await api.get("/expenditures/types/with-counts");
      return response.data;
    } catch (error) {
      console.error("Error fetching types with counts:", error);
      throw error;
    }
  },

  // Bulk operations
  bulkUpdateCategories: async (updates) => {
    try {
      const response = await api.post(
        "/expenditures/categories/bulk-update",
        updates
      );
      return response.data;
    } catch (error) {
      console.error("Error bulk updating categories:", error);
      throw error;
    }
  },

  bulkUpdateTypes: async (updates) => {
    try {
      const response = await api.post(
        "/expenditures/types/bulk-update",
        updates
      );
      return response.data;
    } catch (error) {
      console.error("Error bulk updating types:", error);
      throw error;
    }
  },

  // Import categories from CSV
  importCategoriesFromCSV: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await api.post(
        "/expenditures/categories/import",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error importing categories:", error);
      throw error;
    }
  },

  // Import types from CSV
  importTypesFromCSV: async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await api.post("/expenditures/types/import", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error importing types:", error);
      throw error;
    }
  },
};
